import {
    Component,
    KEY_ARROW_DOWN,
    KEY_ARROW_LEFT,
    KEY_ARROW_RIGHT,
    KEY_ARROW_UP,
    KEY_ENTER,
    KEY_ESCAPE,
    KEY_TAB,
} from '@contorion/core';
import { SearchService } from '../services/search.service';
import { SearchComponent } from './search.component';

export class SearchInputComponent extends Component {
    protected lastValue: string = '';

    get value() {
        return this.element.value;
    }

    set value(value) {
        this.element.value = value;
    }

    constructor(
        protected element: HTMLInputElement,
        protected searchComponent: SearchComponent,
        protected service: SearchService,
        protected flyout: boolean,
    ) {
        super(element);

        this.initEvents();
    }

    public reset() {
        this.value = this.lastValue;
    }

    protected initEvents() {
        if (this.value.length) {
            this.service.value.next(this.value);
            this.lastValue = this.value;
        }

        this.service.value.subscribe((value: string) => {
            this.value = value;
        });

        if (!this.flyout) {
            return;
        }

        this.service.keyboardEvent.subscribe(this.onKeyboardEvent.bind(this));

        this.element.addEventListener('click', this.onClick.bind(this));
        this.element.addEventListener('keyup', this.onKeyUp.bind(this));
        this.element.addEventListener('keydown', this.onKeyDown.bind(this));
    }

    protected onKeyDown(e: KeyboardEvent) {
        if (e.keyCode === KEY_ENTER) {
            e.preventDefault();
        }

        if (e.keyCode !== KEY_TAB) {

            return;
        }
        e.preventDefault();
        this.service.keyboardEvent.next(e);
    }

    protected onClick(): void {
        this.searchComponent.search();
    }

    protected onKeyUp(e: KeyboardEvent) {
        if (e.keyCode === KEY_TAB) {
            return;
        }

        if (e.keyCode === KEY_ENTER) {
            e.preventDefault();
        }

        this.service.keyboardEvent.next(e);
    }

    protected onKeyboardEvent(e: KeyboardEvent) {
        if (e === null) {
            return;
        }

        switch (e.keyCode) {
            case KEY_ARROW_DOWN:
            case KEY_TAB:
            case KEY_ARROW_UP:
            case KEY_ARROW_RIGHT:
            case KEY_ARROW_LEFT:
                // do nothing
                break;
            case KEY_ESCAPE:
                this.reset();

                break;
            default:
                if (this.value !== this.lastValue) {
                    this.service.value.next(this.value);
                    this.searchComponent.search();
                }

                break;
        }
    }
}
